import http from '@/http'

export default {
  namespaced: true,
  actions: {
    async getRatings() {
      const response = await http.get(`supplier/rating`)

      return response
    },
  },
}
